import { render, staticRenderFns } from "./LegacyDeviceManagementService.vue?vue&type=template&id=68f0fd36&"
import script from "./LegacyDeviceManagementService.vue?vue&type=script&lang=js&"
export * from "./LegacyDeviceManagementService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports